const state = {
  status: "loading",
  error: null,
  data: null,
  document: {},
};

export default state;
